import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ClientAppComponent} from './client-app.component';
import {ClientRoutingModule} from './client-routing.module';
import {ClientModule} from './client/client.module';
import {CoreModule} from './core/core.module';
import {ProfileModule} from './profile/profile.module';
import {SharedModule} from './shared/shared.module';

@NgModule({
  imports: [
    BrowserModule,
    ClientRoutingModule,
    CoreModule,
    HttpClientModule,
    ClientModule,
    SharedModule.forRoot(),
    ProfileModule.forRoot(),
    BrowserAnimationsModule
  ],
  declarations: [ClientAppComponent],
  bootstrap: [ClientAppComponent]
})
export class ClientAppModule {
}
